// extracted by mini-css-extract-plugin
module.exports = {"base":"Organizations_base__h7xu-","cell":"Organizations_cell__2Ztyw"};